module.exports = {
	extends: [
		'/',
		'base',
		'tabStrip',
		'big',
		'tab',
	],

	config: {
		static: {
			title: '???',
		}
	},
};